<div class="u-shadow-mini" style="position: relative;">
  <app-loader [showLoader]=showLoad></app-loader>

  <div class="c-portlet_box_specs">
    <div
      class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap">
      <div class="o-stack__cell">
        <h5> {{sectiontitle}} {{timezone}}</h5>
        <span>
          <a href="javascript:void(0)" class="datatable_download_icon" (click)="downloadCSV($event)" target="_blank"
            *ngIf="downloadConfiguration && downloadConfiguration.enableDownload">
            <i class="fa fa-download" aria-hidden="true"></i>
          </a>
        </span>
      </div>
    </div>
    <div class="analytics-portlet-content" style="position: relative; height: 630px">
      <div class="o-stack o-stack--nowrap o-stack--center ht-100">
        <div class="donut-chart-container">
          <div class="chart-wrapper" *ngIf="hasData">
            <div class="chart-inner">
              <div id="chartElement" style="width:100%; height: 100%;">
              </div>
            </div>
          </div>
          <div style="position:absolute; top: calc(50% - 25px); left: 40%;" *ngIf="!hasData">
            No Data Available.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>